import { kebabCase } from 'lodash';
import { openModal } from '../../redux/modules/modals/actions';
import React, { useEffect } from 'react';
import { CONTACT_ACCOUNT_TEAM_MODAL } from '../../redux/modules/modals/modals.module';
import { isAPP, isRAS } from '../../utils/advice/advice-utility';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../config/config';
import {
  APP_TOLL_FREE_NUMBER,
  RAS_SUPPORT_PHONE_NUMBER,
} from '../../settings/settings';
import {
  getHeadshotRequestStatus,
  getNormalAdvisorHeadshot,
} from '../../redux/modules/advisorHeadshot/advisorHeadshot.selectors';
import { getAdvisorHeadshot } from '../../redux/modules/advisorHeadshot/advisorHeadshot.module';

const AccountTeamModal = ({
  financialAdvisor,
  productType,
  RMData,
  ticker,
}) => {
  const dispatch = useDispatch();
  const { isIdle } = useSelector(getHeadshotRequestStatus);
  const sizedHeadshotUrl = useSelector(getNormalAdvisorHeadshot);

  const advisorImageUrl = financialAdvisor?.advisorImageUrl;

  useEffect(() => {
    if (!!advisorImageUrl && isIdle) {
      dispatch(getAdvisorHeadshot(advisorImageUrl));
    }
  }, [dispatch, advisorImageUrl, isIdle]);

  const showAccountModal =
    (isRAS(productType) && financialAdvisor != null) ||
    isAPP(productType) ||
    RMData != null;

  let contactAccountTeamProps = {};

  if (isRAS(productType) && financialAdvisor) {
    contactAccountTeamProps = addRASProps(financialAdvisor, sizedHeadshotUrl);
  } else if (isAPP(productType)) {
    contactAccountTeamProps = addAPPProps();
  } else if (RMData) {
    contactAccountTeamProps = addRMProps(RMData);
  }

  return showAccountModal ? (
    <span>
      Call your{' '}
      <a
        className={`e2e-contact-account-team-${kebabCase(
          ticker
        )} deduction-list-federal-withholding-info`}
        id="contact-account-team"
        onClick={() =>
          dispatch(
            openModal(CONTACT_ACCOUNT_TEAM_MODAL, { contactAccountTeamProps })
          )
        }
      >
        Account Team
      </a>{' '}
      for options
    </span>
  ) : (
    <span className="deduction-list-rm deduction-list-decline">
      Amount Not Available
    </span>
  );
};

export const addRASProps = (financialAdvisor, sizedHeadshotUrl) => {
  return {
    email: financialAdvisor.advisorEmail,
    officePhone: financialAdvisor.advisorPhone
      ? financialAdvisor.advisorPhone.replace(
          /(\d{3})(\d{3})(\d{4})/,
          '$1-$2-$3'
        )
      : RAS_SUPPORT_PHONE_NUMBER,
    displayName: financialAdvisor.advisorName,
    profilePictureUrl: sizedHeadshotUrl,
  };
};

export const addAPPProps = () => {
  return {
    officePhone: APP_TOLL_FREE_NUMBER,
    displayName: 'Contact a Client Specialist',
  };
};

export const addRMProps = (RMData) => {
  const profilePictureRelativePath = RMData?.color96x96?.path
    ? RMData.color96x96.path
    : '';
  const profilePictureUrl = profilePictureRelativePath.startsWith('http')
    ? profilePictureRelativePath
    : `${config.rmlUrl}${profilePictureRelativePath}`;
  return {
    email: RMData.email,
    location: RMData.location,
    officePhone: RMData.officePhone,
    displayName: RMData.person?.displayName,
    profilePictureUrl: profilePictureUrl,
  };
};

export default AccountTeamModal;
